import React from 'react';
import { Pie } from '@ant-design/plots';

const ThemePie = ({ themes }) => {
    const safeThemes = themes || {};
    const data = Object.keys(safeThemes).map(key => ({
        type: key,
        value: safeThemes[key]
    }));

    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        innerRadius: 0.5,
        label: false,
        interactions: [{ type: 'element-active' }],
        tooltip: {
            fields: ['type', 'value'],
            formatter: (datum) => {
                return {
                    name: String(datum.type || 'Unknown'),
                    value: String(datum.value ?? 'N/A'),
                };
            },
        },
        statistic: {
            title: {
                content: 'Themes',
            },
            content: false,
        },
        legend: {
            layout: 'vertical',
            position: 'right',
            pagination: false,
        },
    };

    return <Pie {...config} />;
};

export default ThemePie;
